import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Container, Typography, Card, Divider } from "@mui/material";
import {
  parseCurrency,
  parseDate,
  parseTime,
  mapShopeePayPaymentChannel,
} from "../../utils/tableFunctions";
import { getTransactionDetails } from "../../services/reconciliations";
import ReconDetailsHeader from "./ReconDetailsHeader";
import { Box } from "@mui/system";
import { isObjectEmpty } from "../../utils/appUtils";
import { showVisInstalmentInfo } from "../../utils/terminal_dynamic_util";
import CircularLoader from "../../components/circularLoader";

const TransactionDetails = ({ userRole, itemId }) => {
  const [details, setDetails] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [refs, setRefs] = useState([]);

  const { id = itemId } = useParams();
  useEffect(() => {
    if (!loaded) {
      getTransactionDetails(id, setDetails, setRefs, setLoaded);
    }
  }, [id, loaded]);

  const renderReconciledCard = (detail) => {
    return (
      <>
        <Card sx={{ p: 3 }}>
          <Box>
            <Grid
              container
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 2, sm: 2, md: 2 }}
              sx={{ mt: 5 }}
            >
              <Grid item xs={6} md={6}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Transaction ID</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={7}
                    sx={{
                      overflowWrap: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {detail.id}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Terminal ID</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail.terminal && detail.terminal.terminal_id}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Transaction Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {`${parseDate(detail.transaction_datetime)} ${parseTime(
                      detail.transaction_datetime
                    )}`}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Transaction State
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail.transaction_state &&
                      detail.transaction_state.transaction_state}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Transaction Type
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail?.transaction_type?.transaction_type}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Payment Brand
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail?.payment_brand?.name}
                  </Grid>
                  {detail?.shopeepay_transaction_info?.payment_channel && (
                    <>
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Payment Channel
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={7}>
                        {mapShopeePayPaymentChannel(
                          detail?.shopeepay_transaction_info?.payment_channel
                        )}
                      </Grid>
                    </>
                  )}
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Reference Number
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail?.reference_number}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Host Trace No.
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail?.host_trace_no}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} md={6}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Base Amount</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail.base_currency &&
                      `${detail.base_currency} ${parseCurrency(
                        detail.base_amount,
                        detail.base_currency
                      )}`}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Transaction Amount
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail.transaction_currency &&
                      `${detail.transaction_currency} ${parseCurrency(
                        detail.transaction_amount,
                        detail.transaction_currency
                      )}`}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">FX Rate</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail.fx_rate}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Receipt Number</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail.receipt_number}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Original Id</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail.original_id}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Payment Host</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail?.payment_host?.name}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Business Entity</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {detail?.business_entity?.business_name}
                  </Grid>
                  {detail.is_installment === true && (
                    <>
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Is Installment
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={7}>
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "#69369E", fontWeight: "bold" }}
                        >
                          YES
                        </Typography>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>

            {showVisInstalmentInfo(detail) && (
              <>
                <Divider sx={{ my: 2 }} />
                <Typography variant="h6">VISA Installment</Typography>
                <Box sx={{ height: 12 }} />
                <Grid
                  container
                  direction={{ xs: "column", sm: "row" }}
                  spacing={{ xs: 2, sm: 2, md: 2 }}
                  sx={{ mt: 16 }}
                >
                  <Grid item xs={6} md={6}>
                    <Grid container spacing={2} alignItems="center">
                      {/* V Plan ID */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">V Plan ID</Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.v_plan_id
                          ? detail?.transaction_info?.v_plan_id
                          : "-"}
                      </Grid>
                      {/* Auth Code */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">Auth Code</Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.auth_code
                          ? detail?.transaction_info?.auth_code
                          : "-"}
                      </Grid>

                      {/* Payment Account Reference */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Payment Account Reference
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.payment_account_reference
                          ? detail?.transaction_info?.payment_account_reference
                          : "-"}
                      </Grid>

                      {/* Number of Installment */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Number of Installment
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.number_of_installments
                          ? detail?.transaction_info?.number_of_installments
                          : "-"}
                      </Grid>
                      {/* Installment Frequency */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Installment Frequency
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.installment_frequency
                          ? detail?.transaction_info?.installment_frequency
                          : "-"}
                      </Grid>
                      {/* Selected Plan Name */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Selected Plan Name
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.selected_plan_name
                          ? detail?.transaction_info?.selected_plan_name
                          : "-"}
                      </Grid>

                      {/* Selected Plan Type */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Selected Plan Type
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.selected_plan_type
                          ? detail?.transaction_info?.selected_plan_type
                          : "-"}
                      </Grid>
                      {/* First Installment Fee */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          First Installment Fee
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info?.first_installment_fee
                          )}`}
                      </Grid>
                      {/* First Installment Amount */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          First Installment Amount
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info?.first_installment_amount
                          )}`}
                      </Grid>
                      {/* Selected Plan Name */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          First Installment Upfront Fee
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info
                              ?.first_installment_upfront_fee
                          )}`}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Grid container spacing={2} alignItems="center">
                      {/* Promotion Code */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Promotion Code
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.promotion_code
                          ? detail?.transaction_info?.promotion_code
                          : "-"}
                      </Grid>
                      {/*  Promotion ID */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Promotion ID
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.promotion_id
                          ? detail?.transaction_info?.promotion_id
                          : "-"}
                      </Grid>
                      {/* Total Plan Cost */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Total Plan Cost
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info?.total_plan_cost
                          )}`}
                      </Grid>
                      {/* Total Fees */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">Total Fees</Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info?.total_fees
                          )}`}
                      </Grid>
                      {/* Total Recurring Fees */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Total Recurring Fees
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info?.total_recurring_fees
                          )}`}
                      </Grid>
                      {/* Total Upfront Fees */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Total Upfront Fees
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info?.total_upfront_fees
                          )}`}
                      </Grid>
                      {/*  Annual Percentage Rate */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Annual Percentage Rate
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail?.transaction_info?.annual_percentage_rate
                          ? detail?.transaction_info?.annual_percentage_rate
                          : "-"}
                      </Grid>
                      {/*  Last Installment Fee */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Last Installment Fee
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info?.last_installment_fee
                          )}`}
                      </Grid>
                      {/* Last Installment Amount */}
                      <Grid item xs={6} md={5}>
                        <Typography variant="subtitle1">
                          Last Installment Amount
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        sx={{
                          overflowWrap: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {detail.transaction_currency &&
                          `${detail.transaction_currency} ${parseCurrency(
                            detail?.transaction_info?.last_installment_amount
                          )}`}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Box>
        </Card>
        <Box sx={{ height: 30 }} />
      </>
    );
  };

  return (
    <>
      <Container>
        {loaded ? (
          <>
            <ReconDetailsHeader
              loaded={loaded}
              title="Transaction Details"
              details={details}
              userRole={userRole}
              itemId={itemId}
            />
            {renderReconciledCard(details)}

            {loaded &&
              refs.length > 1 &&
              refs.slice(1).map((trans) => {
                return renderReconciledCard(trans);
              })}
          </>
        ) : (
          <CircularLoader />
        )}
      </Container>
    </>
  );
};

export default TransactionDetails;
